module.exports = __webpack_public_path__ + "media/icons/opony-caloroczne-green@2x-932f1b40.png";